import { render, staticRenderFns } from "./ThePendingChatItem.vue?vue&type=template&id=02c932d6&scoped=true"
import script from "./ThePendingChatItem.vue?vue&type=script&lang=js"
export * from "./ThePendingChatItem.vue?vue&type=script&lang=js"
import style0 from "./ThePendingChatItem.vue?vue&type=style&index=0&id=02c932d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c932d6",
  null
  
)

export default component.exports